import { useTranslation } from "@outschool/localization";

import { useShowCredits } from "../Subscriptions";
import useSubscriptionCredit from "./useSubscriptionCredit";

export default function useEnrollButtonCTA({
  isOngoing,
  isClub,
  isSelfPaced,
  isInProgress,
  isWaitlistable = false,
  sectionProgress,
  showWaitlistedButton = false,
  showNotAcceptingWaitlist = false,
  canEnroll,
}: {
  isOngoing: boolean;
  isClub: boolean;
  isSelfPaced: boolean;
  isInProgress: boolean;
  isWaitlistable?: boolean;
  sectionProgress?: {
    currentWeek: number;
  };
  showWaitlistedButton?: boolean;
  showNotAcceptingWaitlist?: boolean;
  canEnroll: boolean;
}) {
  const { t } = useTranslation(
    "ui-components-website\\hooks\\useEnrollButtonCTA"
  );
  const { hasSubscription } = useSubscriptionCredit();
  const showCredits = useShowCredits();

  if (showCredits && !hasSubscription) {
    return t`Join`;
  }

  if (isInProgress && !!sectionProgress?.currentWeek) {
    return t("Join Week {{currentWeek}}", {
      currentWeek: sectionProgress?.currentWeek,
    });
  }

  return isSelfPaced && canEnroll
    ? t`Enroll Now, Start Anytime`
    : isSelfPaced && !canEnroll
    ? t`Not Accepting Enrollments`
    : showNotAcceptingWaitlist
    ? t`Not Accepting Waitlist`
    : showWaitlistedButton
    ? t`Waitlisted`
    : isWaitlistable
    ? t`Join Waitlist`
    : isOngoing
    ? t`Subscribe`
    : isClub
    ? t`Join Group`
    : isInProgress
    ? t`Enroll Late`
    : t`Enroll`;
}
